<div class="wrapper" [ngClass]="{ invalid: isInvalid$ | async }">
	<label [ngClass]="{ required: isRequired }">{{ label }}</label>
	<ng-content></ng-content>
</div>

<div class="row py-2" *ngIf="(errorMessage$ | async) as errorMessage">
	<span class="col-12" id="errors">
		<fa-icon [icon]="['fas', 'times-circle']"></fa-icon>

		{{ errorMessage }}
	</span>
</div>
